import { ifAuthenticated } from '@/router/before'

export const userPages = [
  {
    path: '/user/profile',
    name: 'ProfileRoute',
    meta: {
      icon: ['fas', 'user'],
      isDisplayInSidebar: true,
      group: 'Слушатель',
      displayName: 'Профиль',
    },
    beforeEnter: ifAuthenticated,
    component: () =>
      import(
        /* webpackChunkName: "ProfileRoute" */ '@/views/user/ProfileRoute.vue'
      ),
  },
  {
    path: '/user/applications',
    name: 'ApplicationsRoute',
    meta: {
      icon: ['fas', 'book'],
      isDisplayInSidebar: true,
      group: 'Слушатель',
      displayName: 'Заявки',
    },
    beforeEnter: ifAuthenticated,
    component: () =>
      import(
        /* webpackChunkName: "ApplicationsRoute" */ '@/views/user/ApplicationsRoute.vue'
      ),
  },
]
